import QuillResize from './QuillResize'
import './assets/resize.scss'

export default QuillResize
